import {
	financialStatementsSelectors,
	gameSelectors,
	loadingActions,
} from '~/store';
import GameService from '~/services/game.service';
// ---- internal imports -----

import * as types from '../actionTypes';
import { getFinancialRatiosFor, getSystemFinancialRatiosFor } from '../selectors';
// ---- parent imports ----

export function updateFinancialRatiosErrorField(errorField) {
	return { type: types.FINANCIAL_STATEMENTS_UPDATE_RATIOS_ERROR_FIELD, errorField};
}

export function updateFinancialRatiosFor(quarterNum, updatedFinancialRatios) {
	return async (dispatch, getState) => {
		const hasAttemptedToSubmitFinancialRatios = financialStatementsSelectors.getHasAttemptedToSubmitFinancialRatios(getState());

		if (hasAttemptedToSubmitFinancialRatios) {
			const errorField = getErrorFieldForFinancialRatios(getState(), quarterNum, updatedFinancialRatios);
			dispatch(updateFinancialRatiosErrorField(errorField));
		}

		dispatch({
			type: types.FINANCIAL_STATEMENTS_UPDATE_FINANCIAL_RATIOS_FOR_QUARTER,
			quarterNum,
			updatedFinancialRatios
		});
	}
}

export function updateFinancialRatiosSubmissionStatusForQuarter(quarterNum, isSubmitted, financialRatios) {
	return { 
		type: types.FINANCIAL_STATEMENTS_UPDATE_RATIOS_SUBMISSION_STATUS_FOR_QUARTER,
		quarterNum,
		isSubmitted,
		financialRatios,	//	Added for missions
	};
}

export function submitFinancialRatiosFor(quarterNum) {
	return async (dispatch, getState) => {
		const hasAttemptedToSubmitFinancialRatios = financialStatementsSelectors.getHasAttemptedToSubmitFinancialRatios(getState());
		const financialRatios = getFinancialRatiosFor(getState(), quarterNum);
		dispatch(loadingActions.start(types.FINANCIAL_STATEMENTS_UPDATE_RATIOS_SUBMISSION_STATUS_FOR_QUARTER));

		const errorField = hasAttemptedToSubmitFinancialRatios
			? financialStatementsSelectors.getFinancialRatiosErrorField(getState())
			: getErrorFieldForFinancialRatios(getState(), quarterNum, financialRatios);

		if (errorField.length === 0) {

			//	save financial statements submission in the backend before the frontend
			//	to assure consistencey
			try {
				const gameUserId = gameSelectors.getGameId(getState());

				const result = await GameService.submitFinancialRatios(gameUserId, quarterNum);

				if (!result.isSuccess) {
					dispatch(loadingActions.endAfterNetworkFaliures());
					return;
				}

				dispatch(updateFinancialRatiosSubmissionStatusForQuarter(
					quarterNum,
					true,
					financialRatios,
				));
			}
			catch(err) {
				console.warn("error", err)
			};
		} else {
			dispatch({
				type: types.FINANCIAL_STATEMENTS_SET_HAS_ATTEMPTED_TO_SUBMIT_RATIOS,
				hasAttemptedToSubmitFinancialRatios: true,
			})
		}

		if (!hasAttemptedToSubmitFinancialRatios) {
			//	This action also set hasAttemptedToSubmitFinancialRatios to true
			dispatch(updateFinancialRatiosErrorField(errorField));
		};

		dispatch(loadingActions.end(types.FINANCIAL_STATEMENTS_UPDATE_RATIOS_SUBMISSION_STATUS_FOR_QUARTER));
	};
}

export function getErrorFieldForFinancialRatios(state, quarterNum, userFinancialRatios) {
	const systemFinancialRatios = getSystemFinancialRatiosFor(state, quarterNum);
	const fieldsToCheck = ['netProfit', 'totalAssets', 'totalEquity', 'grossProfit', 'revenue', 'averageTotalAssets', 'costOfGoodsSold', 'averageInventory']

	for (const field of fieldsToCheck) {
        if (userFinancialRatios[field] !== systemFinancialRatios[field]) {
            return field;
        }
    }

    return '';
}
